import {
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { ConfirmationService } from '@openng/optimus-ui/api';
import { UiConfirmService } from './ui-confirm.service';

/**
 * Makes `UiConfirmService` usable and matches it with the dialog drawn by
 * `<ui-confirm-dialog />`. `ConfirmationService` is not root-provided by the
 * UI kit, so the app has to ask for it once.
 */
export function provideUiConfirm(): EnvironmentProviders {
  return makeEnvironmentProviders([ConfirmationService, UiConfirmService]);
}
